import { connect } from 'react-redux';
import { VIDEO_PRIMARY } from 'constants/InCall/InCallVideo';
import CallOverlaySlide from 'components/InCall/CallOverlaySlide/CallOverlaySlide';
import _get from 'lodash/get';

const mapActionCreators = () => ({});

const mapStateToProps = (state) => {
  const videoLayout = _get(state, 'app.inCallVideo.videoLayout');
  const videoContainerWidth = _get(videoLayout, ['videos', VIDEO_PRIMARY, 'container']);
  const videoWidth = _get(videoLayout, ['videos', VIDEO_PRIMARY, 'width']);
  const isMinimized = _get(state, 'app.inCallVideo.isMinimized');

  return ({
    slide: _get(state, 'app.inCallVideo.slide'),
    isMinimized,
    videoWidth,
    videoContainerWidth,
  });
};

export default connect(mapStateToProps, mapActionCreators)(CallOverlaySlide);
